import * as React from 'react';

interface InfoFieldProps {
  icon?: React.ComponentType<{ className?: string }>;
  label: string;
  value: string | React.ReactNode;
  href?: string;
  mono?: boolean;
}

export function InfoField({
  icon: Icon,
  label,
  value,
  href,
  mono = false,
}: InfoFieldProps) {
  const content = (
    <div className="flex items-start gap-3">
      {Icon && <Icon className="h-4 w-4 text-slate-400 mt-0.5 shrink-0" />}
      <div className="min-w-0 flex-1">
        <p className="text-xs font-medium uppercase tracking-wider text-slate-500 mb-1">
          {label}
        </p>
        <p
          className={`text-sm font-medium text-slate-900 ${mono ? 'font-mono bg-slate-50 px-2 py-1 rounded inline-block' : ''} ${href ? 'hover:underline hover:text-blue-600 transition-colors' : ''}`}
        >
          {value || '-'}
        </p>
      </div>
    </div>
  );

  if (href) {
    return (
      <a href={href} className="block">
        {content}
      </a>
    );
  }

  return content;
}
